

<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
   <title>FA Check | About Us</title>
  <meta name="title" content="FA Check | About Us">
  <meta name="description" content="Get to know FA Check, your partner in secure verification and streamlined compliance for modern business operations.">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>






<section class="about-hero">
  <div class="about-content">
    <h2>About Us</h2>
    <p>
     Fa Check, a flagship product of Baabuji Venturess Pvt Ltd, is a technology platform providing API-driven digital KYC verification and secure document signing solutions for businesses. Designed as a scalable SaaS infrastructure, Fa Check enables organizations to streamline identity verification processes, ensure regulatory compliance, and enhance operational efficiency.
The platform supports multiple verification services, including PAN, Aadhaar (where permitted), GST, CIN, DIN, bank account validation, and FASTag verification, along with digitally signed document workflows powered by robust encryption standards. Built with a security-first approach, Fa Check ensures end-to-end encrypted data transmission and operates as a reliable intermediary layer without storing sensitive customer data.
Today, Fa Check is used by a growing network of fintech companies, enterprises, and service providers across industries to simplify KYC processes, reduce operational overhead, and enable faster, compliant onboarding experiences.
    </p>
  </div>
</section>

<section class="mission-vision">
  <div class="mv-content">
    <div class="mv-box">
      <h2>Our Mission</h2>
      <p>
        Our mission is simple yet powerful: to build a comprehensive documentation platform that delivers seamless onboarding and a truly paperless experience. 
        We envision a world where businesses no longer struggle with fragmented processes or outdated systems. Instead, we thrive with tools that are intuitive, secure, and designed to make every interaction effortless.
      </p>
    </div>

    <div class="mv-box">
      <h2>Our Vision</h2>
      <p>
        We aspire to create world-class, category-defining technology products that set new benchmarks in the industry. But our vision goes beyond technology; it's about people. 
        By fostering a friendly and inclusive work environment, we nurture creativity, encourage bold ideas, and empower our teams to innovate continuously. 
        Together, we are building solutions that don’t just solve problems — they redefine possibilities.
      </p>
    </div>
  </div>
</section>


<section class="core-values">
  <h2>Our Core Values</h2>
  <p class="section-intro">
    At FA Check, our values are the foundation of everything we do. 
    They guide our decisions, shape our culture, and inspire us to push boundaries.
  </p>

  <div class="values-container">
    <!-- Left side headings -->
    <ul class="values-tabs">
      <li [class.active]="selectedTab === 'ownership'" (click)="selectedTab = 'ownership'">
        Culture of Ownership, Creativity, and Trust
      </li>
      <li [class.active]="selectedTab === 'innovation'" (click)="selectedTab = 'innovation'">
        Innovation at the Core
      </li>
      <li [class.active]="selectedTab === 'collaboration'" (click)="selectedTab = 'collaboration'">
        Collaboration that Drives Impact
      </li>
    </ul>

    <!-- Right side content -->
    <div class="values-content">
      <div *ngIf="selectedTab === 'ownership'" class="tab-content">
        <div class="value-icon">🤝</div>
        <h3>Culture of Ownership, Creativity, and Trust</h3>
        <p>We believe in taking responsibility, thinking differently, and building trust at every level. 
           Every team member is empowered to own their work and contribute meaningfully to our shared success.</p>
      </div>

      <div *ngIf="selectedTab === 'innovation'" class="tab-content">
        <div class="value-icon">💡</div>
        <h3>Innovation at the Core</h3>
        <p>Innovation isn’t just a buzzword, it's our way of life. We constantly explore new ideas, 
           challenge conventional thinking, and find smarter ways to solve big problems that matter.</p>
      </div>

      <div *ngIf="selectedTab === 'collaboration'" class="tab-content">
        <div class="value-icon">🌍</div>
        <h3>Collaboration that Drives Impact</h3>
        <p>We thrive on teamwork. By coming together, sharing perspectives, and making decisions collectively, 
           we ensure that our solutions are stronger, faster, and more impactful.</p>
      </div>
    </div>
  </div>
</section>

<section class="why-choose">
  <h2>Why Choose FA Check?</h2>
  <div class="choose-grid">
    <!-- Box 1 -->
    <div class="choose-card">
      <img src="../../assets/Image/icons8-efficiency-100.png" alt="Efficiency Icon" class="choose-icon">
      <h3>Efficiency & Simplicity</h3>
      <p>A platform designed for efficiency and simplicity.</p>
    </div>

    <!-- Box 2 -->
    <div class="choose-card">
      <img src="../../assets/Image/icons8-creative-person-100.png" alt="Innovation Icon" class="choose-icon">
      <h3>Innovation & Collaboration</h3>
      <p>A team driven by innovation and collaboration.</p>
    </div>

    <!-- Box 3 -->
    <div class="choose-card">
      <img src="../../assets/Image/icons8-technology-100.png" alt="Technology Vision Icon" class="choose-icon">
      <h3>Technology That Lasts</h3>
      <p>A vision focused on building technology that lasts.</p>
    </div>
  </div>

  <p class="choose-footer">
    We are not just building products, we are shaping the future of how organizations work, onboard, and grow.
  </p>
</section>


<section class="team-section">
  <div class="team-container">
    <!-- Left side image -->
    <div class="team-image">
      <img src="../../assets/Image/20944999.jpg" alt="FA Check Team">
    </div>

    <!-- Right side content -->
    <div class="team-content">
      <h2 style="color: #5170ff;" >Our Team – Trusted Experts in Verification & Assurance</h2>
      <p  style="color:black;text-align: justify;">
       At FA Check, our team is at the core of everything we build. Bringing together expertise in backend engineering, API infrastructure, and regulatory compliance, we focus on delivering secure, scalable, and reliable digital verification solutions.
We specialize in building systems that handle high-volume, real-time KYC workflows while maintaining strict data security and privacy standards. Our approach combines technical excellence with a strong understanding of evolving compliance requirements, enabling us to deliver solutions that businesses can trust at scale. Driven by a commitment to innovation and integrity, our team continuously works to improve performance, security, and user experience across the platform.
      </p>
    </div>
  </div>
</section>

<!-- <section class="contact-section">
  <div class="contact-container">
    
    <div class="contact-map">
      
      

      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.1753329554726!2d80.20422967262267!3d13.024504136323385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267bef2a89bbf%3A0x19ce0d2ef6887347!2sTyche%20Payment%20Solutions%20Private%20Limited!5e0!3m2!1sen!2sin!4v1773992783279!5m2!1sen!2sin" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>

    
    <div class="contact-form">
      <h2>Contact Us</h2>
      <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" novalidate>
        
        <div class="form-group">
          <label for="name">Name</label>
          <input id="name" type="text" formControlName="name" [ngClass]="{'is-invalid': submitted && f['name'].errors}">
          <div class="error" *ngIf="submitted && f['name'].errors">
            <small *ngIf="f['name'].errors['required']">Name is required.</small>
            <small *ngIf="f['name'].errors['minlength']">Name must be at least 3 characters.</small>
          </div>
        </div>

        <div class="form-group">
          <label for="email">Email</label>
          <input id="email" type="email" formControlName="email" [ngClass]="{'is-invalid': submitted && f['email'].errors}">
          <div class="error" *ngIf="submitted && f['email'].errors">
            <small *ngIf="f['email'].errors['required']">Email is required.</small>
            <small *ngIf="f['email'].errors['email']">Enter a valid email.</small>
          </div>
        </div>

        <div class="form-group">
          <label for="phone">Phone</label>
          <input id="phone" type="text" formControlName="phone" [ngClass]="{'is-invalid': submitted && f['phone'].errors}">
          <div class="error" *ngIf="submitted && f['phone'].errors">
            <small *ngIf="f['phone'].errors['required']">Phone number is required.</small>
            <small *ngIf="f['phone'].errors['pattern']">Enter a valid 10-digit phone number.</small>
          </div>
        </div>

        <div class="form-group">
          <label for="message">Message</label>
          <textarea id="message" rows="4" formControlName="message" [ngClass]="{'is-invalid': submitted && f['message'].errors}"></textarea>
          <div class="error" *ngIf="submitted && f['message'].errors">
            <small *ngIf="f['message'].errors['required']">Message is required.</small>
            <small *ngIf="f['message'].errors['minlength']">Message must be at least 10 characters.</small>
          </div>
        </div>

        <button type="submit" class="btn-submit">Send Message</button>
      </form>
    </div>
  </div>
</section> -->
